import Builder from './class-builder';

class AllWoodBuilder extends Builder {

  /*
  * Render path for desktop
  */
  getRenderPathDesktop() {
    return this.renderDomain + 'all-wood-spiral/desktop/';
  }

  /*
  * Render path for mobile
  */
  getRenderPathMobile() {
    return this.renderDomain + 'all-wood-spiral/mobile/';
  }

  /*
  * Create image SKU
  * THERE ARE NO RENDERS FOR THIS PRODUCT LINE
  * THERE WILL BE A SINGLE IMAGE IN BOTH DESKTOP/MOBILE SIZES
  * WHATEVER MARY WANTS TO SHOW WE JUST HARDCODE HERE FROM THE S3 BUCKET
  */
  getRenderImage() {
    return 'SW3609SAGW';
  }

  /*
  * Create sku from object
  * The order of the sku matches the spreadsheet from Mary
  */
  setSku() {
    this.sku = this.selection_data.product_line + this.selection_data.width + this.selection_data.height + this.selection_data.tread_profile + this.selection_data.wood_species + this.selection_data.baluster_pattern + this.selection_data.handrail;
  }

  /*
  * Create object from sku
  * The order of the sku matches the spreadsheet from Mary
  */
  getSkuObject(sku) {
    var product_line,
        width,
        height,
        tread_profile,
        wood_species,
        baluster_pattern,
        handrail,
        selection_data = {};

    if (sku) {
      product_line = sku.substring(0, 2);
      width = sku.substring(2, 4);
      height = sku.substring(4, 6);
      tread_profile = sku.substring(6, 7);
      wood_species = sku.substring(7, 8);
      baluster_pattern = sku.substring(8, 9);
      handrail = sku.substring(9, 10);


      selection_data = {
        'product_line' : product_line,
        'width' : width,
        'height' : height,
        'tread_profile' : tread_profile,
        'wood_species' : wood_species,
        'baluster_pattern' : baluster_pattern,
        'handrail' : handrail,
      }
    }

    this.selection_data = selection_data;
    return selection_data;
  }

}

export default AllWoodBuilder;
